import { IPage } from '../models/page-model';
import PagesMapper from '../mappings/pages-mapper';

class PagesService {
    private pagesMapper = new PagesMapper();

    constructor() {}

    public getMyFavoritePages = (HttpService: any) => {
        return this.getPages(this.getMyFavoritePagesQuery(), HttpService);
    }

    public removeFavoritePage = (HttpService: any, id: string) => {
        return this.removePage(this.removeFavoritePageQuery(id), HttpService);
    }

    public addFavoritePage = (HttpService: any, data: {url: string, title: string}) => {
        return this.addPage(this.addFavoritePageQuery(), HttpService, data);
    }

    private getPages = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.getList(url).then((result: IPage[]) => {
                resolve(result.map((page: IPage) => this.pagesMapper.mapPage(page)));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private removePage = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.delete(url).then((result: any) => {
                resolve(result);
            }).catch((error: any) => {
                reject(error)
            });
        })
    }

    private addPage = (url: string, HttpService: any, data: {url: string, title: string}): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.post(url, data).then((result: any) => {
                resolve(result);
            }).catch((error: any) => {
                reject(error)
            });
        })
    }

    private getMyFavoritePagesQuery = (): string => {
        return `/api/userpreferences/my-pages`;
    }

    private removeFavoritePageQuery = (id: string): string => {
        return `/api/userpreferences/my-pages?id=${id}`;
    }

    private addFavoritePageQuery = (): string => {
        return `/api/userpreferences/my-pages`;
    }
}

export default new PagesService();